module.exports = __webpack_public_path__ + "static/media/videoPoster1.a6aeea28.jpg";